import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Typography } from '@/lib/typography';
import { SHARED_UI_LABELS } from '@/config/task-display-config';

export function InvestorsFilterBar({ filters, onFilterChange }) {
    const sectors = ['All', 'AI/ML', 'FinTech', 'HealthTech', 'EdTech', 'SaaS', 'E-commerce', 'Consumer Apps', 'Enterprise Infra', 'Deeptech', 'Logistics', 'Manufacturing', 'Q-commerce', 'Social Commerce', 'Diagnostics', 'ESG', 'Voice'];
    const stages = ['All', 'Pre-Seed', 'Seed', 'Series A', 'Series B', 'Series C+', 'Public', 'Acquired', 'Defunct', 'Stealth'];
    const geos = ['All', 'India', 'US', 'SE Asia', 'Europe', 'Global'];

    return (
        <div className="flex items-center gap-4 p-4 bg-card rounded-lg border border-border" data-testid="investors-filter-bar">
            <div className="flex-1 max-w-[200px]">
                <label className="text-muted-foreground mb-1 block">Sector</label>
                <Select
                    value={filters.sector || 'All'}
                    onValueChange={(value) => onFilterChange('sector', value === 'All' ? '' : value)}
                >
                    <SelectTrigger data-testid="filter-sector">
                        <SelectValue placeholder={SHARED_UI_LABELS.selectSector} />
                    </SelectTrigger>
                    <SelectContent>
                        {sectors.map((sector) => (
                            <SelectItem key={sector} value={sector}>
                                {sector}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>

            <div className="flex-1 max-w-[200px]">
                <label className="text-muted-foreground mb-1 block">Stage</label>
                <Select
                    value={filters.stage || 'All'}
                    onValueChange={(value) => onFilterChange('stage', value === 'All' ? '' : value)}
                >
                    <SelectTrigger data-testid="filter-stage">
                        <SelectValue placeholder={SHARED_UI_LABELS.selectStage} />
                    </SelectTrigger>
                    <SelectContent>
                        {stages.map((stage) => (
                            <SelectItem key={stage} value={stage}>
                                {stage}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>

            <div className="flex-1 max-w-[200px]">
                <label className="text-muted-foreground mb-1 block">Geography</label>
                <Select
                    value={filters.geo || 'All'}
                    onValueChange={(value) => onFilterChange('geo', value === 'All' ? '' : value)}
                >
                    <SelectTrigger data-testid="filter-geo">
                        <SelectValue placeholder={SHARED_UI_LABELS.selectGeography} />
                    </SelectTrigger>
                    <SelectContent>
                        {geos.map((geo) => (
                            <SelectItem key={geo} value={geo}>
                                {geo}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>
        </div>
    );
}
